import React from 'react';
import styled from 'styled-components';
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useState } from 'react';
import SrMyCartItemTr from './SrMyCartItemTr';
import { syncUserCartAction, removeUserCartProdAction, updateUserCartProdInfoAction } from '../../modules/su/userCartModule';
import { remove, findIndex, forEach, find } from 'lodash';
import Modal from 'react-modal';
import NormalPopup, { customModalStyles } from '../common/popup/NormalPopup';
import NormalPopupOneBtn from '../common/popup/NormalPopupOneBtn';
import EsReqPopup, { EsReqPopupModalStyles } from '../common/popup/EsReqPopup';
import LoginPopup, { LoginPopupStyles } from '../common/popup/LoginPopup';
import { useHistory, Link } from 'react-router-dom';

import {isMobileOnly} from 'react-device-detect';
import { reqEsItemListAction, reqEsItemListIngAction } from '../../modules/es/esItemModule';

import CheckBtn from '../common/button/CheckBtn';
import { setCartCheckInfoAction, cart_check_info, setCartInputInfoAction } from '../../modules/su/userProdModule';
import * as F from '../../lib/util/CommonFunctions';
//import { FormatNumber, showAmount } from '../../lib/util/CommonFunctions';
import CurrencyInputComp from '../common/input/CurrencyInputComp';
import AnimateHeight from 'react-animate-height';
import * as CONSTANTS from '../../lib/util/Constants';

const SrMyCartListItemBlock = styled.div`
    //margin-bottom: 80px;

`;
const MobileSrMyCartListItemBlock = styled.div`
    margin: 0;
    
    .brand-logo {float:left; width:30vw; object-fit: cover;}
    .brand-total {display: flex;align-items: center; justify-content: space-between;}
    .btn-quote-container {
      display: block;
      height: 100px;
      
      .btn-quote-block {
        display: block;
        position:relative;
        margin-top:10px;
        z-index:9;
        &.fixed {
          position:fixed;bottom:0;margin-top:0;z-index: 10;
          button { font-weight: 600;}
        }
        .btn-text { display: flex; justify-content: space-around; align-items: center; }        
     }      
    }   
`;

const SrMyCartListItemTitleBlock = styled.div`
    border-bottom: none;
    height: 7px;
    ${isMobileOnly&&`
        height: 60px;
        padding: 13px 0;
        //border-bottom:1px solid #cccccc;
        font-size: 16px;
        font-weight: 500;
        color: #333333;
        position: relative;
    `};
    
    ::after {
        content: "";
        display: block;
        clear: both;
      }
`;

const SrMyCartListItemTableBlock = styled.table`
      width: 100%;
`;

const SrMyCartListItemTdBlock = styled.td`
    //background-color: rgba(0, 217, 184, 0.1);
    padding: 20px 0 19px;
    vertical-align: middle;
    border-top: 1px solid #ccc;
    font-size: 15px;
    text-align: center;
`;
const SrMyCartListItemThBlock = styled.th`
    //padding: 8px 0px 5px 0;
    vertical-align: middle;
    //border-top: 2px solid #111;
    font-size: 18px;
    text-align: center;
    font-weight: 500;
    height : 63px;
    color : #333333;
    position: relative;
`;

const SrMyCartListItemLogoBtnBlock = styled.button`
      float: left;
      margin-left: 10.5px;
      margin-right: 10px;
      margin-top: 3px;
`;

const SrMyCartListItemThNumBlock = styled.span`
    ${isMobileOnly?`
    font-size: 14px; 
    margin-top: 7px;  
    `:`
    font-size: 16px;
    margin-top: 6px;
    `};
    
    font-weight: 500;
    float: left;
    
    .gray {
        color : #999999;  
    }
`;

const SrMyCartListItemThArrowSpanBlock = styled.span`
    ${isMobileOnly?`
    padding-top: 12px;
    padding-bottom: 20px;
    width: 17px; 
    `:`
    padding-top: 20px;
    padding-bottom: 20px;
    width: 60px;
    `};

    float: right;
    
    //height: 70px;
    background: url(/assets/images/icon/da-icon.png) center center/auto no-repeat;

    &.active {
        background: url(/assets/images/icon/da-icon-active.png) center center/auto no-repeat;
    }
`;

const SrMyCartItemTrOpenblock = styled.div`
    ${isMobileOnly?`
    width: 92vw;
    height: 50px;
    top: 0px;
    left: 0vw;
    z-index: -1;
    `:`
    width: 976px;
    height: 50px;
    top: 0px;
    left: 200px;
    position: absolute;
    `};
    //position: relative;
    
    
`;
const SrMyCartListItemBottomBlock = styled.div`
    position: relative;
    float: left;
    min-width: 150px;
    //min-height: 130px;
    padding: 20px 10px;
    border-radius: 65px;
    //background-color: #e0e0e0;
    text-align: center;
    width: 214px;

    &.minus-icon::after {
    top: 50%;
    right: -10px;
    width: 20px;
    height: 20px;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    z-index: 1;
    }

    &.equal-icon::after {
        top: 50%;
        right: -10px;
        width: 20px;
        height: 20px;
        -webkit-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
        z-index: 1;
      }
`;

const SrMyCartListItemBottomTitleBlock = styled.div`
    line-height: 1.71;
    display: block;
    margin-bottom: 10px;
    color: #111111;
    font-size: 14px;
    font-weight: normal;
    text-align:center;
    height: 20px;
`;

const SrMyCartListItemInputBlock = styled.input`

`;

const SrMyCartListItemBottomPriceBlock = styled.div`
    ${isMobileOnly?`
    margin-bottom: 10px;
    float: left;
    `:`
    height: 27px;
    line-height: 1.2;
    `};
`;

const SrMyCartItemTrColLineBlock = styled.div`
    width: 0;
    height: 55px;
    border-left: solid 1px #cccccc;
    float: left;
    margin-top: 20px;
`;
const SrMyCartItemTrLineBlock = styled.div`
    width: 100%;
    height: 2px;
    //margin: 135px 0 0;
    background-color: #111111;
`;

const SrMyCartItemTitleLineBlock = styled.div`
    width: 100%;
    height: 1px;
    background-color: #cccccc;
`;

const MobileSrMyCartListCostContainerBlock = styled.div`
    background-color: #fafafa;
    margin-top: 10px;
    margin-bottom: 20px;
    padding: 20px 20px 20px 0;
`;

const MobileSrMyCartListCostBlock = styled.div`
      float: right;
`;

const MobileSrMyCartListInputBlock = styled.div`
      float: right;
`;

const MAX_CNT= CONSTANTS.MAX_RQST_CNT;

const SrMyCartListItem = ({ cartItem, brnd_id, removeBrand }) => {
    const dispatch = useDispatch();
    const history = useHistory();

    const refBtnQuote = useRef(null);

    const [curItem, setCurItem] = useState(null);
    const [totalPrice, setTotalPrice] = useState(0);
    const [totalCnt, setTotalCnt] = useState(0);
    const [msg1, setMsg1] = useState("");
    const [msg2, setMsg2] = useState("");
    const [msg3, setMsg3] = useState("");
    const [kind, setKind] = useState(0);
    const [curIdx, setCurIdx] = useState(0);
    const [openModal, setOpenModal] = useState(false);
    const [openLoginModal, setOpenLoginModal] = useState(false);
    const [availCnt, setAvailCnt] = useState(5);
    const [normalPrice, setNormalPrice] = useState(0);
    const [salePrice, setSalePrice] = useState(0);
    const priceRef = useRef(null);
    const headRef = useRef(null);
    const [countCheck, setCountCheck] = useState(0);
    const [open, setOpen] = useState(true);

    const { accessToken, cartProdList, esItems, prodCartSoldInfo, prodCartCheckInfo, prodCartInputInfo } = useSelector(
        ({ userReducer, userCartReducer, esItemsReducer, userProdReducer }) => ({
            accessToken: userReducer.accessToken,
            cartProdList: userCartReducer.cartProdList,
            esItems: esItemsReducer.esItems,
            prodCartSoldInfo: userProdReducer.prodCartSoldInfo,
            prodCartCheckInfo: userProdReducer.prodCartCheckInfo,
            prodCartInputInfo: userProdReducer.prodCartInputInfo,
        })
    );


    useEffect(() => {
        setCurItem(cartItem);

        let totlaPrice = 0;
        let totalCnt = 0;

        forEach(cartItem, (curobj, index) => {
            curobj.es_prdct_price = (curobj.es_opt_pirce * 1) * curobj.qty;
            totlaPrice += (curobj.es_prdct_price * 1);
            totalCnt += (curobj.qty * 1);
        });

    }, [cartItem])

    useEffect(() => {
        // if (accessToken !== null) {
        //     setOpenLoginModal(false);
        // }
    }, [accessToken]);

    useEffect(() => {
        if (esItems !== null && esItems !== undefined) {
            const cnt = (MAX_CNT - esItems.length)<0?0:(MAX_CNT - esItems.length)
            try {
                if (esItems[0][0].rqst_status !== '050106') {
                    setAvailCnt(cnt)
                }
            } catch (e) { }
        }

    }, [esItems, accessToken])

    useEffect(() => {
        let tPrice = 0; //할인된 상품 금액
        let sPrice = 0; //상품 할인 금액
        let nPrice = 0; //정상 상품 가격
        let count = 0;
        if(prodCartCheckInfo !== null && prodCartCheckInfo !== undefined){
            forEach(curItem, (curobj, index) => {
                if(getSoldOutInfo(curobj)=== false){
                    let idx = findIndex(prodCartCheckInfo, (curitem) => {
                        return (curitem.prdct_id === curobj.prdct_id && curitem.opt_id === curobj.opt_id);
                    })

                    if(idx >= 0) {
                        nPrice += prodCartCheckInfo[idx].prdct_price*1*prodCartCheckInfo[idx].qty*1;
                        tPrice += prodCartCheckInfo[idx].es_opt_pirce*1*prodCartCheckInfo[idx].qty*1;
                        count++;
                    }
                }
            });
        }
        setCountCheck(count);
        setTotalPrice(tPrice);
        setNormalPrice(nPrice);
        sPrice = nPrice - tPrice;
        setSalePrice(sPrice);

    }, [prodCartCheckInfo])

    if (curItem === null) {
        return <SrMyCartListItemBlock />
    }

    // All Delete Button Click
    const handleAllDeleteBtnClick = (value) => {
        // 팝업 표시
        // % 브랜드 % 의 상품들을 모두 삭제하시겠습니까 ?
        setKind(0);
        setMsg1(cartItem[0].brnd_nm + "의");
        setMsg2("상품들을 모두 삭제하시겠습니까 ?");
        setOpenModal(true);
    }

    // Tr 에서 상품 삭제 버튼 클릭 처리
    const handlerRemoveRow = (value) => {

        deleteProd(value);
        /* if (curItem.length === 1) {
            setCurIdx(value);
            // 팝업 표시
            setKind(0);
            setMsg1("");
            setMsg2("상품 옵션을 삭제하시겠습니까?");
            setMsg3("");
            setOpenModal(true);

        } else {
            deleteProd(value);
        } */
    }

    const handleDelClickFromReqPopup = (prdct_id, opt_id) => {

        let idx = findIndex(curItem, (target) => {
            return target.prdct_id === prdct_id && target.opt_id === opt_id;
        })

        if (curItem.length === 1) {

            if (idx !== -1) {
                setCurIdx(idx);
                // 팝업 표시
                setKind(0);
                setMsg1("");
                setMsg2("상품 옵션을 삭제하시겠습니까?");
                setMsg3("");
                setOpenModal(true);
            }

        } else {
            deleteProd(idx);
        }
    }

    // 상품 삭제 처리
    const deleteProd = (value) => {
        let checkInfo = [];
        Object.assign(checkInfo, prodCartCheckInfo);

        //console.log("checkInfo before = " + JSON.stringify(checkInfo))
        remove(checkInfo, (obj) => {
            return (curItem[value].prdct_id === obj.prdct_id && curItem[value].opt_id === obj.opt_id);
        })

        dispatch(setCartCheckInfoAction(checkInfo));
        //console.log("checkInfo after = " + JSON.stringify(checkInfo))

        if (accessToken !== null) {

            // 기존에 브랜드 아이디가 없는 항목은 삭제
            // 옵션 아이디가 unique 하므로 비교하여 삭제 / 옵션이 없는 경우를 위해 상품 아이디도 같이 비교
            remove(cartProdList, (obj) => {
                return (obj.prdct_id === curItem[value].prdct_id && obj.opt_id === curItem[value].opt_id);
            })
            dispatch(syncUserCartAction(cartProdList));
        } else {
            let targeItem = curItem[value];
            // console.log(JSON.stringify(targeItem))
            dispatch(removeUserCartProdAction(targeItem));
        }

        // 모든 상품이 삭제 되었다면, 부모에게 브랜드 아이템 삭제 요청 처리
        /* if (curItem.length === 1) {
            removeBrand(brnd_id);
        } else {
            // 삭제 처리
            if (accessToken !== null) {

                // 기존에 브랜드 아이디가 없는 항목은 삭제
                // 옵션 아이디가 unique 하므로 비교하여 삭제 / 옵션이 없는 경우를 위해 상품 아이디도 같이 비교
                remove(cartProdList, (obj) => {
                    return (obj.prdct_id === curItem[value].prdct_id && obj.opt_id === curItem[value].opt_id);
                })
                dispatch(syncUserCartAction(cartProdList));
            } else {
                let targeItem = curItem[value];
                // console.log(JSON.stringify(targeItem))
                dispatch(removeUserCartProdAction(targeItem));
            }

            // curItem.splice(value, 1);
            // setCurItem(curItem);
        } */


    }

    // 개수 변경
    const handlerChangeQty = (prdct_id, opt_id, value) => {


        let idx = findIndex(cartProdList, (curItem) => {
            return curItem.prdct_id === prdct_id && curItem.opt_id === opt_id
        })

        if (idx !== -1) {
            cartProdList[idx].qty = value;

            if (accessToken !== null) {
                dispatch(syncUserCartAction(cartProdList));
            } else {
                dispatch(updateUserCartProdInfoAction(cartProdList[idx]));
            }
        }

    }

    // 확인 처리
    const handleModalBtn1Click = () => {
        removeBrand(brnd_id);
        setOpenModal(false);
    }

    // 닫기
    const handleModalBtn2Click = () => {
        //dispatch(reqEsItemListAction());
        dispatch(reqEsItemListIngAction());
        setOpenModal(false);
    }

    const handleModalBtnSoldOutClick = () => {
        setOpenModal(false);
        setKind(2);
        setOpenModal(true);
    }

    const getSoldOutInfo = (item) => {
        if(accessToken !== null) {
            //console.log("item = " + JSON.stringify(item));
            if(item !== null && item.sell_status !== '020102') {
                return true;
            }
            else if(item !== null && item.opt_id > 0 && item.opt_status < 1){
                return true;
            }
        }

        if(prodCartSoldInfo !== null && prodCartSoldInfo.length > 0){
            let info = find(prodCartSoldInfo, (curitem) => {
                return curitem.prdct_id === item.prdct_id && curitem.opt_id === item.opt_id;
            });

            //console.log("info = " + JSON.stringify(info));
            if(info !== undefined && info !== null && info.sell_status !== undefined && info.sell_status !== null && info.sell_status !== '020102') {
                return true;
            }
            else if(info !== undefined && info !== null && info.opt_id !== undefined && info.opt_id !== null && info.opt_id > 0 && info.opt_status < 1){
                return true;
            }
        }

        return false;
    }

    const getTotalCount = () => {
        let totalcount = 0;
        forEach(curItem, (curobj, index) => {
            if(getSoldOutInfo(curobj)=== false){
                curobj.es_prdct_price = (curobj.es_opt_pirce * 1) * curobj.qty;
                //totlaPrice += (curobj.es_prdct_price * 1);
                totalcount += (curobj.qty * 1);
            }

        });

        return totalcount;
    }

    const getTotalPrice = () => {
        let totalprice = 0;
        forEach(curItem, (curobj, index) => {
            if(getSoldOutInfo(curobj) === false){
                curobj.es_prdct_price = (curobj.es_opt_pirce * 1) * curobj.qty;
                totalprice += (curobj.es_prdct_price * 1);
                //totalcount += (curobj.qty * 1);
            }

        });

        return totalprice;
    }

    const getItemList = () => {
        let itemList = [];
        forEach(curItem, (curobj, index) => {
            if(getSoldOutInfo(curobj) === false){
                //curobj.es_prdct_price = (curobj.es_opt_pirce * 1) * curobj.qty;
                //totalprice += (curobj.es_prdct_price * 1);
                //totalcount += (curobj.qty * 1);
                itemList.push(curobj);
            }

        });

        return itemList;
    }

    const haveSoldItem = () => {
        let result = false;
        forEach(curItem, (curobj, index) => {
            if(getSoldOutInfo(curobj) === false){

            }
            else{
                result = true;
            }

        });

        return result;
    }
    // 요청하기 버튼 선택
    const handlerEsReq = () => {
        let count = getTotalCount();
        if(count < 1){
            return;
        }
        if (count < CONSTANTS.MIN_ITEM) {
            setKind(1);
            setMsg1(`견적 요청은 ${CONSTANTS.MIN_ITEM}개 이상의`);
            setMsg2("상품을 담아주시면 가능해요!");
            setMsg3(cartItem[0].brnd_nm + "의 상품을 더 담아주세요:-)");
            setOpenModal(true);
        } else if (count > CONSTANTS.MAX_PROD) {
            setKind(1);
            let msg = `견적 요청은 ${CONSTANTS.MAX_PROD}개 이하만\n 가능합니다!\n 조금만 덜어주세요. :-) `;
            setMsg1("");
            setMsg2(msg);
            setMsg3("");
            setOpenModal(true);
        } else {
            if(haveSoldItem() === true){
                setKind(3);

                let msg = "품절된 옵션이 있습니다.\n 제외 후 요청서 페이지로 이동합니다!";
                setMsg1("");
                setMsg2(msg);
                setMsg3("");
                setOpenModal(true);
                return;
            }
            setKind(2);
            setOpenModal(true);
            /* if (accessToken !== null) {
                // 요청하기
                setKind(2);
                setOpenModal(true);
            } else {
                history.push("/login");
                //setOpenLoginModal(true);
            } */
        }
    }

    const getPopup = () => {
        if (kind === 0) {
            return (<NormalPopup
                text={msg1}
                text2={msg2}
                text3={msg3}
                btn1="확인" btn2="취소"
                onClick1={handleModalBtn1Click}
                onClick2={handleModalBtn2Click} />)
        } else if (kind === 1) {
            return (<NormalPopupOneBtn
                text={msg1}
                text2={msg2}
                text3={msg3}
                btn="확인"
                onClick={handleModalBtn2Click} />);
        } else if (kind === 3) {
            return (<NormalPopup
                text={msg1}
                text2={msg2}
                text3={msg3}
                btn1="확인" btn2="취소"
                onClick1={handleModalBtnSoldOutClick}
                onClick2={handleModalBtn2Click} />)
        } else {
            return (<EsReqPopup
                totalPrice={getTotalPrice()}
                totalCnt={getTotalCount()}
                availCnt2={availCnt}
                cartItem={getItemList()}
                onCloseClick={handleModalBtn2Click}
                handlerChangeCnt={handlerChangeQty}
                handlerDelClick={handleDelClickFromReqPopup} />);
        }

    }

    const getPopupStyle = () => {
        if (kind < 2) {
            return customModalStyles;
        } else if (kind === 3) {
            return customModalStyles;
        } else {
            return EsReqPopupModalStyles;
        }
    }

    const checkHeaderPosition = (item, props) => {
        // console.log('header',item.brnd_nm, item, props)
        if(props.currentPosition === 'inside' && props.previousPosition !== 'above') refBtnQuote.current.classList.add('fixed')
        else if(props.currentPosition === 'below' && props.previousPosition === 'inside') refBtnQuote.current.classList.remove('fixed')
    }
    const checkBottomPosition = (item, props) => {
        // console.log('footer',item.brnd_nm, item, props)
        if(props.currentPosition === 'above') refBtnQuote.current.classList.remove('fixed')
        else if(props.currentPosition === 'inside' && props.previousPosition === 'above') refBtnQuote.current.classList.add('fixed')
    }

    const handleCheckClick = (value) => {

        if (value) {
            let checkInfo = [];
            Object.assign(checkInfo, prodCartCheckInfo);

            forEach(curItem, (curobj, index) => {
                remove(checkInfo, (obj) => {
                    return (curobj.prdct_id === obj.prdct_id && curobj.opt_id === obj.opt_id);
                })
            });

            forEach(curItem, (curobj, index) => {
                if(getSoldOutInfo(curobj)=== false){
                    let info = {};
                    Object.assign(info, cart_check_info)
                    info.brnd_id = curobj.brnd_id;
                    info.prdct_id = curobj.prdct_id;
                    info.qty = curobj.qty;
                    info.es_opt_pirce = curobj.es_opt_pirce;
                    info.prdct_price = curobj.prdct_price;
                    if(curobj.prdct_price === curobj.sale_price) {
                        info.prdct_price = curobj.es_opt_pirce;
                    }
                    info.opt_id = curobj.opt_id;
                    if(getSoldOutInfo(curobj) ) {
                        info.isSoldOut = true;
                    } else {
                        info.isSoldOut = false;
                    }
                    checkInfo.push(info);
                }
            });

            dispatch(setCartCheckInfoAction(checkInfo));
            //console.log("checkInfo = " + JSON.stringify(checkInfo))
        } else {
            let checkInfo = [];
            Object.assign(checkInfo, prodCartCheckInfo);

            forEach(curItem, (curobj, index) => {
                remove(checkInfo, (obj) => {
                    return (curobj.prdct_id === obj.prdct_id && curobj.opt_id === obj.opt_id);
                })
            });
            dispatch(setCartCheckInfoAction(checkInfo));
            //console.log("checkInfo del = " + JSON.stringify(checkInfo))
        }
    }

    // 체크 상태 확인
    const getCheckStatus = () => {
        let ret = true;
        let countSoldOut = 0;
        forEach(curItem, (curobj, index) => {
            if(getSoldOutInfo(curobj)=== false){
                let idx = findIndex(prodCartCheckInfo, (curitem) => {
                    return (curitem.prdct_id === curobj.prdct_id && curitem.opt_id === curobj.opt_id);
                })

                if(idx < 0) {
                    ret =  false;
                }


            } else {
                countSoldOut++;
            }
        });

        if(priceRef !== null && priceRef.current !== null) {
            let idx = -1;
            let inputInfo = [];
            Object.assign(inputInfo, prodCartInputInfo);
            //console.log("inputInfo = " + inputInfo);
            if(inputInfo!== null && inputInfo.length > 0) {
                idx = findIndex(inputInfo, (curitem) => {
                    return (curitem.brnd_id === curItem[0].brnd_id);
                })
            }


            if(idx < 0) {
                let data = {'brnd_id': curItem[0].brnd_id, 'inputRef':priceRef, 'headRef':headRef}
                //let tmpItem = { 'brnd_id': key, 'list': value };
                //console.log("data = " + JSON.stringify(data));
                inputInfo.push(data);
                dispatch(setCartInputInfoAction(inputInfo));

                //console.log("inputInfo = " + inputInfo.length);
            } else if(priceRef !== inputInfo[idx].inputRef) {
                remove(inputInfo, (curitem) => {
                    return (curitem.brnd_id === curItem[0].brnd_id);
                })

                let data = {'brnd_id': curItem[0].brnd_id, 'inputRef':priceRef, 'headRef':headRef}
                //let tmpItem = { 'brnd_id': key, 'list': value };
                //console.log("data = " + JSON.stringify(data));
                inputInfo.push(data);
                dispatch(setCartInputInfoAction(inputInfo));
            }
        }

        if(countSoldOut === curItem.length) {
            return false;
        }

        return ret;
    }

    const handleOpen = () => {
        setOpen(!open);
    }

    const handleChangePrice = (value, name) => {
        // console.log("value : " + value + " , name : " + name);
        //setPrice(value);
    }

    // 패키지 금액 포커서 확인
    const handleChangeCurInputFocus = () => {
        // console.log("handleChangeCurInputFocus")
        //setFocused(true);
    }

    const handleChangeCurInputBlur = () => {
        // console.log("handleChangeCurInputBlur")
        //setFocused(false);
    }

    return (isMobileOnly?
        <MobileSrMyCartListItemBlock>

            <SrMyCartListItemTitleBlock ref={headRef}>

                <div style={{ float: 'left' }} >
                <CheckBtn onClick={handleCheckClick} defaultValue={getCheckStatus()}/>
                </div>
                <div >
                <Link to={"/brHome/" + cartItem[0].brnd_id} target="_blank">
                    <SrMyCartListItemLogoBtnBlock>{cartItem[0].brnd_nm}</SrMyCartListItemLogoBtnBlock>
                </Link>
                </div>
                <SrMyCartListItemThNumBlock> {countCheck}<span className="gray"> / {cartItem.length}</span></SrMyCartListItemThNumBlock>

                <SrMyCartListItemThArrowSpanBlock className={open? "active":"none"} onClick={handleOpen} ></SrMyCartListItemThArrowSpanBlock>
                <SrMyCartItemTrOpenblock onClick={handleOpen}/>
            </SrMyCartListItemTitleBlock>
            <AnimateHeight duration={300} height={(open ? 'auto' : '0')} className="clearfix">
                <SrMyCartItemTitleLineBlock/>
            <div>
                {
                    cartItem.map((trItem, index) => {
                        return (
                          <SrMyCartItemTr
                            rowspan={curItem.length}
                            key={(trItem.prdct_id) * 1 + index}
                            item={trItem}
                            idx={index}
                            removeRow={handlerRemoveRow}
                            updateCnt={handlerChangeQty}
                            reqEs={handlerEsReq}
                            disabled={availCnt<1  ? true: getTotalCount() === 0 ? true:false/*견적가능수량이 1이상인 경우만 enable*/ }
                          />);
                    })
                }

                <MobileSrMyCartListCostContainerBlock className="clearfix">
                    <div className="clearfix">
                    <MobileSrMyCartListCostBlock className="clearfix">
                    <SrMyCartListItemBottomPriceBlock>
                            {normalPrice*1 === 0 ?
                            <span style={{ fontSize:"14px", fontWeight:"500"}}>0<span style={{ fontSize:"14px", fontWeight:"normal"}}>원</span></span>
                            :
                            F.showAmount({amount:normalPrice, fontSize:"14px", weight:"500", unit:"원", falseVal:"0원", unitWeight:'normal',unitFontSize:"14px" })
                            }
                        </SrMyCartListItemBottomPriceBlock>
                        <SrMyCartListItemBottomPriceBlock><span>&nbsp;-&nbsp;</span></SrMyCartListItemBottomPriceBlock>
                        <SrMyCartListItemBottomPriceBlock>
                            {salePrice*1 === 0 ?
                                <span style={{ fontSize:"14px", fontWeight:"500"}}>0<span style={{ fontSize:"14px", fontWeight:"normal"}}>원</span></span>
                                :
                                F.showAmount({amount:salePrice, fontSize:"14px", weight:"500", unit:"원", falseVal:"0원", unitWeight:'normal',unitFontSize:"14px" })
                            }
                        </SrMyCartListItemBottomPriceBlock>
                        <SrMyCartListItemBottomPriceBlock><span>&nbsp;=&nbsp;</span></SrMyCartListItemBottomPriceBlock>
                        <SrMyCartListItemBottomPriceBlock>
                            {totalPrice*1 === 0 ?
                            <span style={{ fontSize:"14px", fontWeight:"500"}}>0<span style={{ fontSize:"14px", fontWeight:"normal"}}>원</span></span>
                            :
                            F.showAmount({amount:totalPrice, fontSize:"14px", weight:"500", unit:"원", falseVal:"0원", unitWeight:'normal',unitFontSize:"14px" })
                            }
                        </SrMyCartListItemBottomPriceBlock>
                    </MobileSrMyCartListCostBlock>
                    </div>
                    <div className="clearfix">
                    <MobileSrMyCartListInputBlock className="clearfix">

                                <span className="fontsize-12 f-left"
                                    style={{ marginTop: '12px', fontSize:'12px', color: '#333333' }} >
                                    희망 견적 금액
                                </span>
                                <CurrencyInputComp
                                    marginLeft='10px'
                                    width='120px'
                                    height='40px'
                                    float='left'
                                    marginRight='-13px'
                                    placeholder='0'
                                    onChange={handleChangePrice}
                                    onFocus={handleChangeCurInputFocus}
                                    onBlur={handleChangeCurInputBlur}
                                    maxLength='14'
                                    inputRef={priceRef}
                                    textAlign='right'
                                    fontWeight='400'
                                    fontSize='12px'
                                />

                                <span style={{ position: 'relative', right: '12px', top: '10px',fontSize:'12px' }}>
                                    원
                                </span>
                    </MobileSrMyCartListInputBlock>
                    </div>
                </MobileSrMyCartListCostContainerBlock>

            </div>

            {/* <div className="btn-quote-container">
            <div id={`btn-quote-block-${cartItem[0].id}`} className="btn-quote-block" ref={refBtnQuote} onClick={availCnt>0?handlerEsReq:null}>
                {getTotalCount() === 0 ?
                <NormalSmallBtn
                marginBottom="10px"
                height="60px"
                width="92vw"
                display='inline-block'
                bgColor={'#ccc'}
                textColor={'#999'} fontSize="1.2rem" fontWeight="400"
                text={`${cartItem[0].brnd_nm} 견적 요청하기`}//opens only when slots left
                />
                :
                <NormalSmallBtn
                                marginBottom="10px"
                                height="60px"
                                width="92vw"
                                display='inline-block'
                                bgColor={availCnt>0?'rgb(255,199,66)':'#ccc'}
                                textColor={availCnt>0?'#111':'#999'} fontSize="1.2rem" fontWeight="400"
                                text={`${cartItem[0].brnd_nm} 견적 요청하기`}
                                onClick={()=>availCnt>0?handlerEsReq():null} //opens only when slots left
                />
                }
            </div>
            </div> */}
            </AnimateHeight>
            <SrMyCartItemTrLineBlock/>
            <Modal
              isOpen={openModal}
              onRequestClose={handleModalBtn2Click}
              style={getPopupStyle()}
              onAfterOpen={() => document.body.style.overflow = 'hidden'}
              onAfterClose={() => document.body.removeAttribute('style')}>
                {getPopup()}

            </Modal>

            <Modal
              isOpen={openLoginModal}
              onRequestClose={() => { setOpenModal(false) }}
              style={LoginPopupStyles}
              onAfterOpen={() => document.body.style.overflow = 'hidden'}
              onAfterClose={() => document.body.removeAttribute('style')}>
                <LoginPopup onClosePopup={() => { setOpenModal(false) }}/>
            </Modal>
        </MobileSrMyCartListItemBlock>
        :<SrMyCartListItemBlock>
            <SrMyCartListItemTitleBlock ref={headRef}>
                {/* <NormalSmallBtn float="right" marginBottom="20px" marginTop="5px"
                    display='inline-block'
                    bgColor='transparent'
                    textColor="#999" fontSize="14px" fontWeight="300"
                    text="전체삭제" onClick={handleAllDeleteBtnClick} /> */}
            </SrMyCartListItemTitleBlock>
            <SrMyCartListItemTableBlock>
                

                <thead>
                    <tr>
                        <SrMyCartListItemThBlock colSpan="7" >
                        <SrMyCartItemTrOpenblock onClick={handleOpen}/>
                            <div style={{ float: 'left' }}>
                            <CheckBtn onClick={handleCheckClick} defaultValue={getCheckStatus()}/>
                            </div>
                            <Link to={"/brHome/" + cartItem[0].brnd_id} target="_blank">
                                <SrMyCartListItemLogoBtnBlock>{cartItem[0].brnd_nm}</SrMyCartListItemLogoBtnBlock>
                            </Link>
                            <SrMyCartListItemThNumBlock> {countCheck}<span className="gray"> / {cartItem.length}</span></SrMyCartListItemThNumBlock>

                            <SrMyCartListItemThArrowSpanBlock className={open? "active":"none"}></SrMyCartListItemThArrowSpanBlock>
                        </SrMyCartListItemThBlock>

                    </tr>
                </thead>
                <AnimateHeight duration={300} height={(open ? 'auto' : '0')} className="clearfix">
                <tbody>
                    {
                        cartItem.map((trItem, index) => {
                            return (
                                <SrMyCartItemTr
                                    rowspan={curItem.length}
                                    key={(trItem.prdct_id) * 1 + index}
                                    item={trItem}
                                    idx={index}
                                    removeRow={handlerRemoveRow}
                                    updateCnt={handlerChangeQty}
                                    reqEs={handlerEsReq}
                                    disabled={availCnt<1 ? true: getTotalCount() === 0 ? true:false/*견적가능수량이 1이상인 경우만 enable*/ }
                                />);
                        })
                    }
                </tbody>

                <tfoot>
                    <tr>
                        <SrMyCartListItemTdBlock colSpan='7' style={{ width: '1176px'}}>
                            <div style={{ display: 'flex', justifyContent: 'center', width:'760px', float:'left'}}>


                            <SrMyCartListItemBottomBlock className="minus-icon">
                                <SrMyCartListItemBottomTitleBlock>정상 금액</SrMyCartListItemBottomTitleBlock>
                                <SrMyCartListItemBottomPriceBlock>
                                    {normalPrice*1 === 0 ?
                                    <span style={{ fontSize:"20px", fontWeight:"500"}}>0<span style={{ fontSize:"18px", fontWeight:"normal"}}>원</span></span>
                                    :
                                    F.showAmount({amount:normalPrice, fontSize:"20px", weight:"500", unit:"원", falseVal:"0원", unitWeight:'normal',unitFontSize:"18px" })
                                    }

                                </SrMyCartListItemBottomPriceBlock>
                            </SrMyCartListItemBottomBlock>
                            <SrMyCartListItemBottomBlock className="equal-icon">
                                <SrMyCartListItemBottomTitleBlock>할인 금액</SrMyCartListItemBottomTitleBlock>
                                <SrMyCartListItemBottomPriceBlock>
                                {salePrice*1 === 0 ?
                                    <span style={{ fontSize:"20px", fontWeight:"500"}}>0<span style={{ fontSize:"18px", fontWeight:"normal"}}>원</span></span>
                                    :
                                    F.showAmount({amount:salePrice, fontSize:"20px", weight:"500", unit:"원", falseVal:"0원", unitWeight:'normal',unitFontSize:"18px" })
                                    }
                                </SrMyCartListItemBottomPriceBlock>
                            </SrMyCartListItemBottomBlock>
                            <SrMyCartListItemBottomBlock>
                                <SrMyCartListItemBottomTitleBlock>상품 금액</SrMyCartListItemBottomTitleBlock>
                                <SrMyCartListItemBottomPriceBlock>
                                    {totalPrice*1 === 0 ?
                                    <span style={{ fontSize:"20px", fontWeight:"500"}}>0<span style={{ fontSize:"18px", fontWeight:"normal"}}>원</span></span>
                                    :
                                    F.showAmount({amount:totalPrice, fontSize:"20px", weight:"500", unit:"원", falseVal:"0원", unitWeight:'normal',unitFontSize:"18px" })
                                    }
                                </SrMyCartListItemBottomPriceBlock>
                            </SrMyCartListItemBottomBlock>
                            </div>
                            <div style={{ width: '415px', float:'right'}}>
                            <SrMyCartItemTrColLineBlock/>
                            <div style={{ float: 'right', color:'#333333', marginTop:'27px'}}>

                                <span className="fontsize-15 f-left"
                                    style={{ marginTop: '10px' }} >
                                    희망 견적 금액
                                </span>

                                <CurrencyInputComp
                                    marginLeft='32.5px'
                                    width='172px'
                                    height='40px'
                                    float='left'
                                    marginRight='35px'
                                    placeholder='0'
                                    onChange={handleChangePrice}
                                    onFocus={handleChangeCurInputFocus}
                                    onBlur={handleChangeCurInputBlur}
                                    maxLength='14'
                                    inputRef={priceRef}
                                    textAlign='right'
                                    fontWeight='400'
                                />

                                <span style={{ position: 'relative', right: '65px', top: '9px' }}>
                                    원
                                </span>

                            </div>
                            </div>
                        </SrMyCartListItemTdBlock>
                        {/* <SrMyCartListItemTdBlock colSpan="6" style={{ width: '415px'}}>
                            <SrMyCartItemTrColLineBlock/>
                            <div style={{ float: 'right', color:'#333333'}}>

                                <span className="fontsize-15 f-left"
                                    style={{ marginTop: '10px' }} >
                                    희망 견적 금액
                                </span>

                                <CurrencyInputComp
                                    marginLeft='10px'
                                    width='172px'
                                    height='40px'
                                    float='left'
                                    marginRight='50.5px'
                                    placeholder='0'
                                    onChange={handleChangePrice}
                                    onFocus={handleChangeCurInputFocus}
                                    onBlur={handleChangeCurInputBlur}
                                    maxLength='14'
                                    inputRef={priceRef}
                                    textAlign='right'
                                    fontWeight='400'
                                />

                                <span style={{ position: 'relative', right: '70px', top: '9px' }}>
                                    원
                                </span>

                            </div>
                        </SrMyCartListItemTdBlock> */}
                        {/* <SrMyCartListItemTdBlock>
                            총 수량 <SpanPrice value={totalCnt} isSale={false} />개
                        </SrMyCartListItemTdBlock>
                        <SrMyCartListItemTdBlock>
                            <SpanPckgNavPrice value={totalPrice}
                                fontSize='20px' fontWeight='700' float='none' />
                        </SrMyCartListItemTdBlock> */}
                    </tr>
                </tfoot>
                </AnimateHeight>
                <SrMyCartItemTrLineBlock/>
            </SrMyCartListItemTableBlock>

            <Modal
                isOpen={openModal}
                onRequestClose={handleModalBtn2Click}
                style={getPopupStyle()}
                onAfterOpen={() => document.body.style.overflow = 'hidden'}
                onAfterClose={() => document.body.removeAttribute('style')}>
                {getPopup()}

            </Modal>

            <Modal
                isOpen={openLoginModal}
                onRequestClose={() => { setOpenModal(false) }}
                style={LoginPopupStyles}
                onAfterOpen={() => document.body.style.overflow = 'hidden'}
                onAfterClose={() => document.body.removeAttribute('style')}>
                <LoginPopup onClosePopup={() => { setOpenModal(false) }}/>
            </Modal>
        </SrMyCartListItemBlock>
    );
};

export default SrMyCartListItem;
